export interface InvoiceTimeSnapshot {
  invoiceId: number; jobId: number; shiftId: number; shiftDate: string; timeZone: string;
  actualStart: string; actualEnd: string; arrivalTime: string; endTime: string;
  lunchMinutes: number; downtimeMinutes: number; downtimeRecorded?: boolean; gapUnpaid: boolean;
  totalMinutes: number; unpaidMinutes: number; billableMinutes: number;
  hourlyRateCents: number; travelAllowanceCents: number; totalCents: number;
}
export interface InvoiceDispute {
  id: number; invoiceId: number; jobId: number; state: 'open' | 'accepted' | 'declined' | 'withdrawn';
  openedOn: string; resolvedOn?: string; withdrawalReason?: string;
  original: InvoiceTimeSnapshot; proposed: InvoiceTimeSnapshot; note: string; sourceHash: string;
  officeName: string; talentName: string; canRespond?: boolean; canWithdraw?: boolean;
}
export interface InvoiceDisputeContext {
  invoiceId: number; jobId: number; original: InvoiceTimeSnapshot; officeName: string; talentName: string;
  canPropose: boolean; dispute: InvoiceDispute | null;
}
export interface InvoiceDisputeProposal { arrivalTime: string; endTime: string; lunchMinutes: number; note: string }
export interface InvoiceDisputeReview {
  reviewId: number; reviewToken: string; original: InvoiceTimeSnapshot; proposed: InvoiceTimeSnapshot;
  talentName: string; note: string; reworded: boolean;
}
export interface InvoiceDisputeReceipt {
  invoiceId: number; changed: boolean; dispute: InvoiceDispute; message: string;
  notificationStatus: 'accepted' | 'unconfirmed';
}
export function disputeError(error: any): string {
  return error?.body?.error?.message || error?.body?.message || error?.userMessage || error?.message || 'Unable to load this invoice question. Refresh its status.';
}
export const disputeMoney = (cents: number) => `$${(cents / 100).toFixed(2)}`;
export const disputeDowntime = (value: InvoiceTimeSnapshot) => value.downtimeRecorded === false ? 'not recorded' : `${value.downtimeMinutes} min`;
export function proposalError(original: InvoiceTimeSnapshot, proposed: InvoiceDisputeProposal, talent: string): string {
  if (proposed.arrivalTime === original.arrivalTime && proposed.endTime === original.endTime && proposed.lunchMinutes === original.lunchMinutes) return 'Change at least one time before you continue.';
  if (!proposed.note.trim()) return `Please add a short reason — ${talent} will see this.`;
  return '';
}
